module.exports = __webpack_public_path__ + "media/share_images/mixer-56b4cb2a.svg";